import NoItems from '@/components/ui/NoItems.tsx';

/**
 * Pusty rachunek osoby w rozwiniętym kaflu. Wcięcie własne, bo kafel nie ma
 * paddingu — trzyma go dopiero karta widoku, której tu nie ma.
 */
const EmbeddedBillEmpty = ({
  title,
  description,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  title: string;
  description: string;
}) => (
  <div className="px-7 py-6" {...props}>
    <NoItems title={title} description={description} />
  </div>
);

export default EmbeddedBillEmpty;
